<template>
  <span class="spinner inline-block w-3.5 h-3.5
    border-2 border-white dark:border-gray-800 rounded-xl animate-spin" />
</template>

<style scoped>
.spinner,
.dark .spinner {
  border-top-color: transparent;
}
</style>
